export enum ErrorCodes {
  NOT_AUTHORISED = 'not-authorised',
  NOT_FOUND = 'not-found',
  MISSING_MAIN_ROLE = 'missing-main-role',
  MAINTENANCE_MODE = 'maintenance-mode',
}
